export const SINGLE_CATALOG = Symbol('SINGLE_CATALOG');
export const MULTIPLE_CATALOG = Symbol('MULTIPLE_CATALOG');
